<template>
  <div class="pages">
    <div class="filter">
      <div>
        <el-form size="small" :inline="true">
          <el-form-item label="企业地址">
            <el-cascader
              size="small"
              :options="options"
              v-model="selectedOptions"
              @change="handleChange"
            >
            </el-cascader>
          </el-form-item>
        </el-form>
      </div>
      <div class="search">
        <el-form size="small" :inline="true">
          <el-form-item label="关键字">
            <el-input
              v-model="formInline.keyWord"
              placeholder="请输入关键词查询"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searcList">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" height="5.7rem" max-height="5.7rem">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="businessName"
          label="企业名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="businessUser"
          label="企业校区代表人"
          align="center"
        >
        </el-table-column>
        <el-table-column property="schoolName" label="学校信息" align="center">
        </el-table-column>
        <el-table-column property="phone" label="联系方式" align="center">
        </el-table-column>
        <el-table-column
          property="businessAddress"
          label="企业地址"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="medium"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pages justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="currentSize"
          layout="  prev, pager, next,  sizes, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { provinceAndCityDataPlus, CodeToText } from "element-china-area-data";

export default {
  data() {
    return {
      tableData: [],
      formInline: {
        keyWord: "",
      },
      //省市联级
      options: provinceAndCityDataPlus,
      selectedOptions: [],
      address: ["", ""],
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0,
    };
  },
  created() {
    if (this.$route.params.pageIdx || this.$route.params.pageSize) {
      this.currentPage=this.$route.params.pageIdx
      this.currentSize=this.$route.params.pageSize
      this.getEnterpriceList(this.currentPage, this.currentSize);
    } else {
    this.getEnterpriceList();
    }
  },
  methods: {
    searcList() {
      this.currentPage = 1;
      this.getEnterpriceList(this.currentPage);
    },
    getEnterpriceList(pageIndex = 1, pageSize = 10) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize,
        Keyword: this.formInline.keyWord,
        province: this.address[0],
        city: this.address[1],
      };
      var url = this.$dataConver.getUrl("/admin/QY/GetQYList", params);

      this.$api.get(url).then((res) => {
        if (res.succeed) {
          this.tableData = res.data.items;
          this.totalCount = res.data.total;
          this.tableData.forEach((element) => {
            element.address = element.schoolProvince + element.schoolCity;
          });
        }
      });
    },
    handleClick(val) {
      this.$router.push({
        path: "/userManagement/userDetail",
        query: { role: "company", id: val.id ,pageIdx: this.currentPage, pageSize:this.currentSize}
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;
      this.getEnterpriceList(this.currentPage, this.currentSize);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getEnterpriceList(this.currentPage, this.currentSize);
    },
    handleChange(value) {
      var dz = [];
      if (value[1] != null) {
        dz.push(CodeToText[value[0]]);
        if (CodeToText[value[1]] == "全部") dz.push("");
        else dz.push(CodeToText[value[1]]);
      } else {
        if (CodeToText[value[0]] == "全部") dz.push("");
        else dz.push(CodeToText[value[0]]);
      }
      this.address = dz;
      console.log(this.address);
    },
  },
};
</script>
<style lang="scss" scoped>
.table {
  margin-top: 0.2rem;
  padding: 0.24rem 0.19rem 0.3rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
}
.filter {
  margin-top: 0.3rem;
  padding: 0.25rem 0.19rem 0.23rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
  display: flex;
  justify-content: space-between;
  >>> .el-form-item {
    margin-bottom: 0;
  }
}
.section {
  padding: 0.23rem 0.18rem 0.57rem;
  flex: 1 1 2.4rem;
  border-radius: 0.06rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 1.4rem;
  .name {
    color: rgb(102, 102, 102);
    font-size: 0.18rem;
    font-family: Microsoft YaHei;
    line-height: 0.17rem;
  }
  .number {
    margin-top: 0.17rem;
    color: rgb(51, 51, 51);
    font-size: 0.32rem;
    font-family: Microsoft YaHei;
    line-height: 0.26rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/userManagement/enterprise.vue